import { takeLatest, call, put } from 'redux-saga/effects'

import {
  PROVIDER_DETAILS_REQUEST_ASYNC,
  PROVIDER_DETAILS_REQUEST_SUCCESS,
  PROVIDER_DETAILS_REQUEST_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getProviderDetailSaga(action) {
  try {
    const result = yield call(
      api.getProviderDetailsRequest,
      action.payload.carepointObj
    )
    yield put({
      type: PROVIDER_DETAILS_REQUEST_SUCCESS,
      payload: {
        providerDetail: result.data,
        practiceName: action.payload.practiceName,
      },
    })
  } catch (e) {
    yield put({
      type: PROVIDER_DETAILS_REQUEST_FAILURE,
    })
  }
}

export function* providerDetailsWatcherSaga() {
  yield takeLatest(PROVIDER_DETAILS_REQUEST_ASYNC, getProviderDetailSaga)
}
